import { render, staticRenderFns } from "./LayoutSideBar.vue?vue&type=template&id=0143b513&scoped=true&"
import script from "./LayoutSideBar.vue?vue&type=script&lang=ts&"
export * from "./LayoutSideBar.vue?vue&type=script&lang=ts&"
import style0 from "#/css/layouts/side_bar_layout.scss?vue&type=style&index=0&id=0143b513&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0143b513",
  null
  
)

export default component.exports